import './App.css';

import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { ThemeProvider } from '@emotion/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { theme } from './them';

import Teams from './pages/Teams';
import Dashboard from './pages/Dashboard';
import Announcement from './pages/Announcement';
import Incident from './pages/Incident';
import TeamMemberList from './components/Teams/TeamMemberList';
import CreateTeam from './components/Teams/CreateTeam';
import MethaneForm from './components/Announcement/MethaneForm';
import AnnouncementList from './components/Announcement/AnnouncementList';
import TeamList from './components/Teams/TeamList';
import TeamDetails from './components/Teams/TeamDetails';

import CommandCenter from './pages/CommandCenter';
import ExecutiveDashboard from './pages/ExecutiveDashboard';
import TeamLeaderView from './pages/TeamLeaderView';
import StaffApp from './pages/StaffApp';
import PatientApp from './pages/PatientApp';
import Stakeholders from './pages/Stakeholders';
import Inventory from './pages/Inventory';
import Reports from './pages/Reports';
import Connectivity from './pages/Connectivity';
import Governance from './pages/Governance';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Users from './pages/Users';
import AuditLogs from './pages/AuditLogs';
import RequireAuth from './components/RequireAuth';

function ProtectedLayout() {
  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/activation" element={<Announcement />} >
              <Route path="" index element={<AnnouncementList  title="Announcements"/>} />
              <Route path="announce" element={<MethaneForm simulate={false}/>} />
              <Route path="simulate" element={<MethaneForm simulate={true}/>} />
              <Route path="drills" index element={<AnnouncementList title="Drills"/>} />
            </Route>
            <Route path="/active-incident/:id" element={<Incident />} />
            <Route path="/closed-incident/:id" element={<Incident />} />
            <Route path="/team" element={<Teams />}>
              <Route path="" index element={<TeamList/>} />
              <Route path="add" index element={<CreateTeam/>} />
              <Route path="members" element={<TeamMemberList />} />
              <Route path=":id" element={<TeamDetails />} />
            </Route>

            <Route path="/command" element={<CommandCenter />} />
            <Route path="/executive" element={<ExecutiveDashboard />} />
            <Route path="/team-leader" element={<TeamLeaderView />} />
            <Route path="/staff-app" element={<StaffApp />} />
            <Route path="/patient-app" element={<PatientApp />} />
            <Route path="/stakeholders" element={<Stakeholders />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/users" element={<Users />} />
            <Route path="/audit" element={<AuditLogs />} />
            <Route path="/integrations" element={<Connectivity />} />
            <Route path="/governance" element={<Governance />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
